import React, { useContext, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import is from 'helpers/browserDetect';
import MainLayout from './MainLayout';
import ErrorLayout from './ErrorLayout';
import { ToastContainer } from 'react-toastify';
import { CloseButton } from 'components/common/Toast';
import AppContext from 'context/Context';
import ProjectDashboard from 'components/pages/npd/projects/ProjectDashboard';
import AuthError from 'components/errors/AuthError';
import ProtectedRoute from 'components/authenticated-routes/ProtectedRoute';
import Error404 from 'components/errors/Error404';
import SettingsPanel from 'components/settings-panel/SettingsPanel';
// import SettingsToggle from 'components/settings-panel/SettingsToggle';
import NCDashboard from 'components/pages/new-critical/dashboard/NCDashboard';
import Home from 'components/pages/Home';
import AreaList from 'components/pages/stock-location/areas/AreaList';
import AreaManager from 'components/pages/stock-location/areas/AreaManager';
import SiteList from 'components/pages/stock-location/sites/SiteList';
import SiteManager from 'components/pages/stock-location/sites/SiteManager';
import LocationList from 'components/pages/stock-location/locations/LocationList';
import LocationManager from 'components/pages/stock-location/locations/LocationManager';
import BinList from 'components/pages/stock-location/bins/BinList';
import BinManager from 'components/pages/stock-location/bins/BinManager';
import StockTransactionList from 'components/pages/stock-location/stock-management/StockTransactionList';
import StockSearch from 'components/pages/stock-location/stock-management/StockSearch';
import StockMovement from 'components/pages/stock-location/stock-management/StockMovement/StockMovement';
import StockCheck from 'components/pages/stock-location/stock-management/StockCheck/StockCheck';
import DeliveryDiscrepancyDashboard from 'components/pages/stock-location/delivery-discrepancy/DeliveryDiscrepancyDashboard';
import WpoDashboard from 'components/pages/stock-location/stock-management/WpoDashboard/WpoDashboard';
import StockRequest from 'components/pages/stock-location/stock-management/StockRequest/StockRequest';
import ActionPlanManager from 'components/pages/customer-service/action-plans/create-action-plan/ActionPlanManager';
import ActionPlanDashboard from 'components/pages/customer-service/action-plans/action-plan-dashboard/ActionPlanDashboard';
import Calendar from 'components/pages/customer-service/meetings/calendar/Calendar';
import MeetingDetail from 'components/pages/customer-service/meetings/meeting-detail/MeetingDetail';

import AuthRoute from 'components/authenticated-routes/AuthRoute';
import Error403 from 'components/errors/Error403';
import PermissionSetupList from 'components/pages/permissions/permission-setup/PermissionSetupList';
import UserPermissionList from 'components/pages/permissions/user-permission/UserPermissionList';
import SectionDashboard from 'components/pages/skill-matrix/sections/sections-dashboard/SectionDashboard';
import CustomersFocusDashboard from 'components/pages/meeting-management/customers-focus-dashboard/CustomersFocusDashboard';
import MeetingDashboard from 'components/pages/meeting-management/meeting-dashboard/MeetingDashboard';
import SkillCriteriaDashboard from 'components/pages/skill-matrix/skills/skill-criteria-dashboard/SkillCriteriaDashboard';
import BalancedScorecard from 'components/pages/balanced-scorecard/kpi-details/BalancedScorecard';
import KpiDashboard from 'components/pages/balanced-scorecard/kpi-dashboard/KpiDashboard';
import DepartmentSpending from 'components/pages/reports/department-spending/DepartmentSpending';
import DepartmentSpendingDashboard from 'components/pages/reports/department-spending/DepartmentSpendingDashboard';
import TrainingRecordManager from 'components/pages/skill-matrix/training-record/create-record/TrainingRecordManager';
import CoreTrainingRecord from 'components/pages/skill-matrix/training-record/dashboard/CoreTrainingRecord';
import SkillMatrixDashboard from 'components/pages/skill-matrix/skill-matrix/SkillMatrixDashboard.js';
import AreaDashboad from 'components/pages/skill-matrix/areas/area-dashboard/AreaDashboard';
import SkillLevelDashboard from 'components/pages/skill-matrix/skills/skill-level-dashboard/SkillLevelDashboard';
import SkillActivityDashboard from 'components/pages/skill-matrix/skills/skill-activity-dashboard/SkillActivityDashboard';
import SubSkillDashboard from 'components/pages/skill-matrix/skills/sub-skill-dashboard/SubSkillDashboard';

// Hidden module, see routes/routes.js "IT & Systems" (hidden: true) — not deleted, disabled on purpose
// import JiraProjectManagementDashboard from 'components/pages/it/jira-project-management/index';
import RTLMissingScanned from 'components/pages/production/rtl-missing-scanned';
import QueryList from 'components/pages/dashboard/query/QueryList';
import Query from 'components/pages/dashboard/query/Query';
import DashboardList from 'components/pages/dashboard/dashboard/DashboardList';
import Dashboard from 'components/pages/dashboard/dashboard/Dashboard';
import ManagerProspectDashboard from 'components/pages/salesperson-kpi/sales-manager/ManagerProspectDashboard';
import ManagerKpiTargetDashboard from 'components/pages/salesperson-kpi/sales-manager/ManagerKpiTargetDashboard';
import SalesVisitsDashboard from 'components/pages/salesperson-kpi/sales-manager/SalesVisitsDashboard';
import SalesVisitHistoriesDashboard from 'components/pages/salesperson-kpi/sales-manager/SalesVisitHistoriesDashboard';
import ManagerKpiSummaryDashboard from 'components/pages/salesperson-kpi/sales-manager/ManagerKpiSummaryDashboard';
import ProspectCustomerDashboard from 'components/pages/salesperson-kpi/personal-dashboard/prospect-customer/ProspectCustomerDashboard';
import MyVisitsDashboard from 'components/pages/salesperson-kpi/personal-dashboard/my-visits/MyVisitsDashboard';
import KpiTargetDashboard from 'components/pages/salesperson-kpi/personal-dashboard/kpi-target/KpiTargetDashboard';
import KpiSummaryDashboard from 'components/pages/salesperson-kpi/personal-dashboard/kpi-summary/KpiSummaryDashboard';
import MyVisitHistory from 'components/pages/salesperson-kpi/personal-dashboard/my-visits/History/MyVisitHistory';
import TrainneeDocument from 'components/pages/skill-matrix/training-record/TrainneeDocument/TrainneeDocument';
import AreaSkillLevelConfig from 'components/pages/skill-matrix/areas/area-skill-level-config/AreaSkillLevelConfig';
import SkillMatrixSetting from 'components/pages/skill-matrix/settings/SkillMatrixSetting';
import NewBusinessAnalysisDashboard from 'components/pages/salesperson-kpi/new-business-analysis/NewBusinessAnalysisDashboard';
import Sunflow from 'components/extra/Sunflow';
// Hidden module, see routes/routes.js "Service Desk" (hidden: true) — not deleted, disabled on purpose
// import SDActivity from 'components/pages/service-desk/activity/SDActivity';
// import SDIssue from 'components/pages/service-desk/issue/SDIssue';
// import SDQueue from 'components/pages/service-desk/queue/SDQueue';
// import SDProject from 'components/pages/service-desk/admin/project/SDProject';
// import SDProjects from 'components/pages/service-desk/admin/projects/SDProjects';
// import SDKanban from 'components/pages/service-desk/board/SDKanban';
import ProductionOverviewDashboard from 'components/pages/production/ProductionOverviewDashboard';
import StillageDashboard from 'components/pages/stillage-dashboard/main-page/StillageDashboard';
import LorryLoadingSummaryDashboard from 'components/pages/dashboard/lorry-loading-summary/LorryLoadingSummaryDashboard';
import ChargingSpaceBookingSystem from 'components/pages/charging-space/CharginSpaceBookingSystem';
import ChargingSpaceAdminApproval from 'components/pages/charging-space/ChargingSpaceAdminApproval';
import StillageCollection from 'components/pages/stillage-collection/StillageCollection';
import ElvisHistory from 'components/pages/elvis-history/ElvisHistory';
import NominationPage from 'components/pages/recognition/NominationPage';
import RecognitionReportsPage from 'components/pages/recognition/RecognitionReportsPage';
import GlassDashboard from 'components/pages/glass-management/GlassDashboard';
import GRNsDashboard from 'components/pages/stock-location/stock-management/WpoDashboard/GRNs/GRNsDashboard';
import SupplierDashboard from 'components/pages/supplier-management/supplier-dashboard/Dashboard';
import SupplierDetails from 'components/pages/supplier-management/supplier-details/Details';
import PurchasingHistory from 'components/pages/supplier-management/purchasing-history/PurchasingHistory';
import SupplierOtif from 'components/pages/supplier-management/supplier-otif/SupplierOtif';
import SupplierProductsPage from 'components/pages/supplier-management/supplier-details/SupplierProductsPage';
import ElvisKnowledgeBaseManagement from 'components/pages/elvis-knowledge/ElvisKnowledgeBaseManagement';
import ElvisConversations from 'components/pages/elvis-conversations/ElvisConversations';

const Layout = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  useContext(AppContext);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
  }, [HTMLClassList]);

  return (
    <>
      <Routes>
        {/* {Auth errors} */}
        <Route element={<ErrorLayout />}>
          <Route path="errors/authError" element={<AuthError />} />
        </Route>
        <Route element={<ErrorLayout />}>
          <Route path="author/403Error" element={<Error403 />} />
        </Route>

        {/* {MainLayout}  */}
        <Route path="/" element={<ProtectedRoute />}>
          {/* <Route> */}
          <Route element={<MainLayout />}>
            <Route exact path="/" element={<Home />} />
            <Route exact path="npd/dashboard" element={<ProjectDashboard />} />
            <Route
              exact
              path="customer-service/meetings/:meetingId/action-plan-manager/:actionPlanId"
              element={<ActionPlanManager />}
            />
            <Route
              exact
              path="meeting-management/customer-focus-dashboard"
              element={
                <AuthRoute>
                  <CustomersFocusDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="meeting-management/:id/customer-focus-dashboard"
              element={
                <AuthRoute>
                  <CustomersFocusDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="meeting-management/meeting-dashboard"
              element={
                <AuthRoute>
                  <MeetingDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="production/rtl-missing-scanned"
              element={
                <AuthRoute>
                  <RTLMissingScanned />
                </AuthRoute>
              }
            />

            <Route
              exact
              path="production/production-overview-dashboard"
              element={
                <AuthRoute>
                  <ProductionOverviewDashboard />
                </AuthRoute>
              }
            />

            <Route
              exact
              path="new-critical/nc-dashboard"
              element={<NCDashboard />}
            />
            <Route
              exact
              path="stillages/stillage-dashboard"
              element={<StillageDashboard />}
            />
            <Route exact path="/glass-dashboard" element={<GlassDashboard />} />
            <Route
              exact
              path="stillages/stillage-collection"
              element={<StillageCollection />}
            />
            <Route
              exact
              path="customer-service/action-plan-board"
              element={<ActionPlanDashboard />}
            />
            <Route
              exact
              path="customer-service/action-plan-manager/:id"
              element={<ActionPlanManager />}
            />
            <Route
              exact
              path="customer-service/meetings/calendar"
              element={<Calendar />}
            />
            <Route
              exact
              path="customer-service/meetings/:id"
              element={<MeetingDetail />}
            />
            <Route
              exact
              path="customer-service/service-desk"
              element={<Sunflow />}
            />
            <Route
              exact
              path="hr/skill-matrix/area/area-dashboard"
              element={
                <AuthRoute>
                  <AreaDashboad />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="hr/skill-matrix/section/section-dashboard"
              element={
                <AuthRoute>
                  <SectionDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="hr/skill-matrix/"
              element={
                <AuthRoute>
                  <SkillMatrixDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="hr/skill-matrix/skills/criteria-dashboard"
              element={
                <AuthRoute>
                  <SkillCriteriaDashboard />
                </AuthRoute>
              }
            />

            <Route
              exact
              path="hr/skill-matrix/skills/skill-level-dashboard"
              element={
                <AuthRoute>
                  <SkillLevelDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="hr/skill-matrix/skills/skill-activity-dashboard"
              element={
                <AuthRoute>
                  <SkillActivityDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="hr/skill-matrix/skills/sub-skill-dashboard"
              element={
                <AuthRoute>
                  <SubSkillDashboard />
                </AuthRoute>
              }
            />

            <Route
              exact
              path="hr/skill-matrix/section/skills/core-training-record"
              element={
                <AuthRoute>
                  <TrainingRecordManager />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="hr/skill-matrix/section/skills/core-training-dashboard"
              element={
                <AuthRoute>
                  <CoreTrainingRecord />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="hr/skill-matrix/training-managements/trainee-documents"
              element={
                <AuthRoute>
                  <TrainneeDocument />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="hr/skill-matrix/setting"
              element={
                <AuthRoute>
                  <SkillMatrixSetting />
                </AuthRoute>
              }
            />

            <Route
              exact
              path="hr/charging-space-booking"
              element={
                <AuthRoute>
                  <ChargingSpaceBookingSystem />
                </AuthRoute>
              }
            />

            <Route
              exact
              path="hr/charging-space-admin"
              element={
                <AuthRoute>
                  <ChargingSpaceAdminApproval />
                </AuthRoute>
              }
            />

            <Route
              exact
              path="hr/recognition/nominate"
              element={
                <NominationPage />
              }
            />

            <Route
              exact
              path="hr/recognition/reports"
              element={
                <AuthRoute>
                  <RecognitionReportsPage />
                </AuthRoute>
              }
            />

            <Route
              exact
              path="admin/permission/permissions-setup/permission-setup-dashboard"
              element={
                <AuthRoute>
                  <PermissionSetupList />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="admin/permission/user-permission/user-permission-dashboard"
              element={
                <AuthRoute>
                  <UserPermissionList />
                </AuthRoute>
              }
            />
            <Route
              path="/stock-location/area-management/areas"
              element={
                <AuthRoute>
                  <AreaList />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/area-management/area-manager"
              element={
                <AuthRoute>
                  <AreaManager />
                </AuthRoute>
              }
            />
            <Route
              path="hr/skill-matrix/area/area-skill-level-config"
              element={
                <AuthRoute>
                  <AreaSkillLevelConfig />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/site-management/sites"
              element={
                <AuthRoute>
                  <SiteList />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/site-management/site-manager"
              element={
                <AuthRoute>
                  <SiteManager />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/bin-management/bins"
              element={
                <AuthRoute>
                  <BinList />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/bin-management/bin-manager"
              element={
                <AuthRoute>
                  <BinManager />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/location-management/locations"
              element={
                <AuthRoute>
                  <LocationList />
                </AuthRoute>
              }
            />

            <Route
              path="stock-location/location-management/location-manager"
              element={
                <AuthRoute>
                  <LocationManager />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/stock-management/stock-transaction"
              element={
                <AuthRoute>
                  <StockTransactionList />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/stock-management/stock-search"
              element={
                <AuthRoute>
                  <StockSearch />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/stock-management/stock-movement"
              element={
                <AuthRoute>
                  <StockMovement />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/stock-management/stock-check"
              element={
                <AuthRoute>
                  <StockCheck />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/stock-management/delivery-discrepancy"
              element={
                <AuthRoute>
                  <DeliveryDiscrepancyDashboard />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/stock-management/wpo-dashboard"
              element={
                <AuthRoute>
                  <WpoDashboard />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/stock-management/stock-request"
              element={
                <AuthRoute>
                  <StockRequest />
                </AuthRoute>
              }
            />
            <Route
              path="stock-location/stock-management/wpo/grn/:grnNo"
              element={
                // <AuthRoute>
                <GRNsDashboard />
                // </AuthRoute>
              }
            />
            <Route
              path="kpi-balanced-scorecard/:id"
              element={
                <AuthRoute>
                  <BalancedScorecard />
                </AuthRoute>
              }
            />
            <Route
              path="department-spending-dashboard"
              element={
                <AuthRoute>
                  <DepartmentSpendingDashboard />
                </AuthRoute>
              }
            />
            <Route
              path="department-spending"
              element={
                <AuthRoute>
                  <DepartmentSpending />
                </AuthRoute>
              }
            />
            <Route
              path="kpi-balanced-scorecard"
              element={
                <AuthRoute>
                  <KpiDashboard />
                </AuthRoute>
              }
            />
            <Route
              path="department-spending-dashboard"
              element={
                <AuthRoute>
                  <DepartmentSpendingDashboard />
                </AuthRoute>
              }
            />
            <Route
              path="department-spending"
              element={
                <AuthRoute>
                  <DepartmentSpending />
                </AuthRoute>
              }
            />
            {/* Hidden module, see routes/routes.js "IT & Systems" (hidden: true) — not deleted, disabled on purpose
            <Route
              exact
              path="it/jira-project-management"
              element={
                <AuthRoute>
                  <JiraProjectManagementDashboard />
                </AuthRoute>
              }
            />
            */}
            <Route
              exact
              path="dashboard/list"
              element={
                <AuthRoute>
                  <DashboardList />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="dashboard/edit/:id"
              element={
                <AuthRoute>
                  <Dashboard edit></Dashboard>
                </AuthRoute>
              }
            />
            <Route
              exact
              path="dashboard/view/:id"
              element={
                <AuthRoute>
                  <Dashboard></Dashboard>
                </AuthRoute>
              }
            />
            <Route
              exact
              path="dashboard/queries"
              element={
                <AuthRoute>
                  <QueryList />
                </AuthRoute>
              }
            />

            <Route
              exact
              path="dashboard/lorry-loading-sumary/dashboard"
              element={
                <AuthRoute>
                  <LorryLoadingSummaryDashboard />
                </AuthRoute>
              }
            />

            {/* Hidden module, see routes/routes.js "Service Desk" (hidden: true) — not deleted, disabled on purpose
            <Route
              exact
              path="service-desk/activity"
              element={<SDActivity></SDActivity>}
            />
            <Route exact path="service-desk/board" element={<SDKanban />} />
            <Route
              exact
              path="service-desk/issue/:issueId"
              element={<SDIssue />}
            />
            <Route
              exact
              path="service-desk/queue/:queueType"
              element={<SDQueue />}
            />

            <Route
              exact
              path="service-desk/admin/projects"
              element={<SDProjects />}
            />
            <Route
              exact
              path="service-desk/admin/project/:projectId"
              element={<SDProject />}
            />
            */}

            <Route
              exact
              path="dashboard/query/:id"
              element={
                <AuthRoute>
                  <Query />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="salesperson-kpi/sales-manager/prospect-customers"
              element={
                <AuthRoute>
                  <ManagerProspectDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="salesperson-kpi/sales-manager/sales-visits"
              element={
                <AuthRoute>
                  <SalesVisitsDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="salesperson-kpi/sales-manager/sales-visits/history"
              element={
                <AuthRoute>
                  <SalesVisitHistoriesDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="salesperson-kpi/sales-manager/kpi-targets"
              element={
                <AuthRoute>
                  <ManagerKpiTargetDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="salesperson-kpi/sales-manager/kpi-summary"
              element={
                <AuthRoute>
                  <ManagerKpiSummaryDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="salesperson-kpi/personal-dashboard/prospect-customers"
              element={
                <AuthRoute>
                  <ProspectCustomerDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="salesperson-kpi/personal-dashboard/my-visits"
              element={
                <AuthRoute>
                  <MyVisitsDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="salesperson-kpi/personal-dashboard/my-visits-history"
              element={
                <AuthRoute>
                  <MyVisitHistory />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="salesperson-kpi/personal-dashboard/kpi-target"
              element={
                <AuthRoute>
                  <KpiTargetDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="salesperson-kpi/personal-dashboard/kpi-summary"
              element={
                <AuthRoute>
                  <KpiSummaryDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="salesperson-kpi/new-business-analysis"
              element={
                <AuthRoute>
                  <NewBusinessAnalysisDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="salesperson-kpi/new-business-analysis"
              element={
                <AuthRoute>
                  <LorryLoadingSummaryDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="/elvis"
              element={
                // <AuthRoute>
                <ElvisHistory />
              }
            />
            <Route
              exact
              path="/elvis-conversations"
              element={
                <AuthRoute>
                  <ElvisConversations />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="/elvis-knowledge"
              element={
                <AuthRoute>
                  <ElvisKnowledgeBaseManagement />
                </AuthRoute>
              }
            />
            <Route
              path="supplier/supplier-dashboard"
              element={
                <AuthRoute>
                  <SupplierDashboard />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="supplier/supplier-details/:id"
              element={
                <AuthRoute>
                  <SupplierDetails />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="supplier/purchasing-history"
              element={
                <AuthRoute>
                  <PurchasingHistory />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="supplier/supplier-otif/:id"
              element={
                <AuthRoute>
                  <SupplierOtif />
                </AuthRoute>
              }
            />
            <Route
              exact
              path="supplier/supplier-products/:id"
              element={
                // <AuthRoute>
                <SupplierProductsPage />
                // </AuthRoute>
              }
            />
          </Route>
        </Route>

        {/* {Fallback <Navigate to="/errors/404" />} */}
        <Route path="*" element={<Error404 />} />
      </Routes>

      {/* {Customisation menu} */}
      {/* <SettingsToggle /> */}
      <SettingsPanel />
      {/* {toast container for whole app} */}
      <ToastContainer
        toastClassName="text-white"
        closeButton={CloseButton}
        icon={false}
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
      />
    </>
  );
};

export default Layout;
